
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name:'headerItem',
components: {
Flexbox,
FlexboxItem
},
props: {

},
data() {
return {
active:'index',
content:'',
userinfo:{}
};
},
watch: {
'$route' (to, from) {
this.init();
}
},
created () {
this.init();
},
methods: {
init () {

this.userinfo = this.isLogin();
if (!this.$route.name) {
this.active = 'index';
} else if (this.$route.name == 'xxxly' && this.$route.query.mtype == 1){
this.active = 'ismenus';
} else {
this.active = this.$route.name;
}
},
goUrl (name) {
window.open(name);
},
serachFun () {
if (!this.content) {
this.$vux.alert.show({title:'错误',content:'搜索内容不能为空！'});
return;
}
this.$router.push({name:'serachResult',query:{content:this.content}});
},
sign () {
window.location.href = 'http://student.hebeijiaoyu.com.cn/glwz/member/zc';
},
login () {
this.$router.push({name:'login'});
},
unsign () {
localStorage.setItem('userInfo',JSON.stringify({}));
this.$router.push({name:'index'});
this.$router.go(0);
},
user () {
this.$router.push({name:'user'});
}
}
}



// WEBPACK FOOTER //
// ./src/views/header/header.vue